const map = {
  beginning_of_period: 'Início do período',
  end_of_period: 'Final do período',
  day_of_month: 'Dia do mês',
}

export default str => map[str] || str
